import { FC } from 'react';
import type { ReactElement } from 'react';
import DefaultLayout from './DefaultLayout';

const NoFooterLayout: FC<{ children: ReactElement }> = ({ children }) => (
  <DefaultLayout hideFooter>{children}</DefaultLayout>
);

export default NoFooterLayout;
